

import { FC } from 'react';
import styled from 'styled-components';
import { FlexBox, FInter } from '@brg/ui';

export interface NavbarLangSwitchWidgetTheming {
    buttonColor: string;
    buttonHoverColor: string;
}

export const NavbarLangSwitchWidgetButton = styled(FlexBox)<NavbarLangSwitchWidgetTheming>`
    height: 64px;
    user-select: none;
    align-items: center;
    cursor: pointer;
    color: ${(p: NavbarLangSwitchWidgetTheming) => p.buttonColor};
    transition: all 0.2s;
    &:hover {
        color: ${(p: NavbarLangSwitchWidgetTheming) => p.buttonHoverColor};
    }
`;

export interface NavbarLangSwitchWidgetProps {
    theming: NavbarLangSwitchWidgetTheming;
    onClick?: () => void;
    title: string;
}

export const NavbarLangSwitchWidget: FC<NavbarLangSwitchWidgetProps> = (props) => {
    return (
        <NavbarLangSwitchWidgetButton onClick={props.onClick} {...props.theming}>
            <FInter.SmallText>{props.title}</FInter.SmallText>
        </NavbarLangSwitchWidgetButton>
    );
};


import { FC } from 'react';
import styled from 'styled-components';
import { FlexBox, FInter } from '@brg/ui';

export interface NavbarLangSwitchWidgetTheming {
    buttonColor: string;
    buttonHoverColor: string;
}

export const NavbarLangSwitchWidgetButton = styled(FlexBox)<NavbarLangSwitchWidgetTheming>`
    height: 64px;
    user-select: none;
    align-items: center;
    cursor: pointer;
    color: ${(p: NavbarLangSwitchWidgetTheming) => p.buttonColor};
    transition: all 0.2s;
    &:hover {
        color: ${(p: NavbarLangSwitchWidgetTheming) => p.buttonHoverColor};
    }
`;

export interface NavbarLangSwitchWidgetProps {
    theming: NavbarLangSwitchWidgetTheming;
    onClick?: () => void;
    title: string;
}

export const NavbarLangSwitchWidget: FC<NavbarLangSwitchWidgetProps> = (props) => {
    return (
        <NavbarLangSwitchWidgetButton onClick={props.onClick} {...props.theming}>
            <FInter.SmallText>{props.title}</FInter.SmallText>
        </NavbarLangSwitchWidgetButton>
    );
};
